<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div class="container">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 2)">
                                <span>STEP2.이미지 매핑</span>
                            </li>
                            <li class="on" @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP3.이미지 크롭</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 4)">
                                <span>STEP4.막장 사진대지</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 5)">
                                <span>STEP5.강도정보</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->
                <div class="pic-edit-wrapper">
                    <table class="fms_photo">
                        <colgroup>
                            <col style="width:70%" />
                            <col style="width:30%" />
                        </colgroup>
                        <tr style="height: 35px;">
                            <th>
                                이미지 크롭
                                <button type="button" class="btn btn-file origin" @click="onClickedCropBtn">
                                    <span>크롭하기</span>
                                </button>
                            </th>
                            <th>막장면 이미지</th>
                        </tr>
                        <tr>
                            <td style="height: 530px;">
                                <vue-cropper
                                    v-if="rockJudgmentImageUrl"
                                    ref="cropper"
                                    :src="rockJudgmentImageUrl"
                                    :aspect-ratio="720 / 720"
                                    style="height: 520px;"
                                    @ready="onCropperReady"
                                />
                            </td>
                            <td>
                                <div id="cropImgUrl" />
                                <div id="svgContainer" style="display: none; " />
                                <img id="threeDimensionalImageUrl" :src="threeDimensionalImageUrl" height="360" />
                            </td>
                        </tr>
                        <tr>
                            <th colspan="2">
                                지질면 이미지
                            </th>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <div
                                    style="margin-top: 20px;  display: flex; align-items: center;justify-content: center"
                                >
                                    <img id="threeDimensionalFile1Url" :src="threeDimensionalFile1Url" height="160" />
                                </div>
                            </td>
                        </tr>
                    </table>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-cancel" @click="prev(data.tunnelConstructionMethod, 2)">
                            <span>이전으로</span>
                        </button>
                        <button
                            type="button"
                            class="btn btn-next"
                            @click="saveAndNext(data.tunnelConstructionMethod, 4)"
                        >
                            <span>저장 및 다음으로</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';

/* [2021/03/27] added */
import FacemappingCanvas from '../helper/FacemappingCanvasHelper';
/* end of [2021/03/27] */

import 'cropperjs/dist/cropper.css';
import VueCropper from 'vue-cropperjs';

export default {
    name: 'Step3',
    components: {
        VueCropper
    },
    data: () => {
        return {
            id: null,
            dataType: 'base',
            navClose: '',
            gnbShow: '',
            data: {
                id: null,
                station: '',
                rockJudgmentImageUrl: ''
            },
            facemappingCanvas: null,
            rockJudgmentImageUrl: '',
            threeDimensionalImageUrl: '',
            threeDimensionalFile1Url: '',
            cropImg: null,
            isCrop: false
        };
    },
    computed: {
        ...mapState({
            stateData: state => {
                return JSON.parse(JSON.stringify(state.facemapping.data));
            }
        })
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.hideLoading();
    },
    created() {},
    mounted() {
        //ScreenHelper.setLandscape();
        this.id = this.$route.params.id;
        this.facemappingCanvas = FacemappingCanvas();

        /* end of [2021/03/27] */
        if (this.id !== null) {
            this.dataObj();
        }
        this.hideLoading();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading', 'alert']),
        backbtn() {
            this.$router.go(-1);
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        prev(tunnelConstructionMethod, step) {
            this.$router.push({ path: `/step` + step + `/${this.data.id}` });
        },
        nextStep(tunnelConstructionMethod, step) {
            if (step === 5) {
                this.$router.push({ path: `/step4/` + this.data.constructionName + `/${this.data.id}` });
            } else {
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            }
        },
        dataObj() {
            this.showLoading();
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;

                this.rockJudgmentImageUrl = this.data.rockJudgmentImageUrl;

                this.threeDimensionalImageUrl = this.data.threeDimensionalImageUrl;
                this.threeDimensionalFile1Url = this.data.threeDimensionalFile1Url;

                //this.$refs.rockJudgmentImageUrl
                /*
                this.frontImageUrl = this.data.frontImageUrl !== null ? FILE_URL + this.data.frontImageUrl : null;
                this.frontImage = this.data.frontImage;
                this.frontImageOriginUrl = this.data.frontImageOriginUrl;
                this.frontImageOrigin = this.data.frontImageOrigin;

                if (this.data.frontImageOrigin === null) {
                    this.originFileBtnCss = 'min-width: 60px;background-color: #8f8f96';
                }
                */

                /* [2021/03/27] */
                //this.facemappingCanvas.initData(this.data);
                /* end of [2021/03/27] */

                this.hideLoading();
            });
        },
        getImageBase64OfCurrentSvg() {
            /* [2023/12/13] modified */

            const $svgParent = $('#svgContainer');
            var $svg = $svgParent.find('svg');

            // Serialize svg to string
            var svgString = new XMLSerializer().serializeToString($svg[0]);
            var decoded = unescape(encodeURIComponent(svgString));
            var base64 = btoa(decoded);
            base64 = `data:image/svg+xml;base64,${base64}`;
            return base64;
        },
        svgUrlToPng(svgUrl) {
            const svgImage = document.createElement('img');
            svgImage.style.position = 'absolute';
            svgImage.style.top = '-9999px';
            document.body.appendChild(svgImage);
            svgImage.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = svgImage.clientWidth;
                canvas.height = svgImage.clientHeight;
                const canvasCtx = canvas.getContext('2d');
                canvasCtx.drawImage(svgImage, 0, 0);
                const imgData = canvas.toDataURL('image/png');
                //callback(imgData);
                this.cbForFunction(imgData);
                // document.body.removeChild(imgPreview);
            };
            svgImage.src = svgUrl;
        },
        cbForFunction(pngData) {
            const blob = this.base64ToBlob(pngData);

            const imageName = 'STA NO_3D_' + new Date().getTime() + '.png';

            const formData = new FormData();
            formData.append('file_id', '');
            formData.append('file_name', imageName);
            formData.append('file', blob);
            //formData 로 fileUpload 하면 됨
            FileApi.blolImgUpload(formData).then(res => {
                console.log(res);
                this.data.threeDimensionalImage = res.content.fileId;
                this.saveProcess();
            });

            /*
            $.ajax({
                type: 'POST',
                enctype: 'multipart/form-data',
                url: '/api/file/blolImgupload',
                data: formData,
                processData: false,
                contentType: false,
                cache: false,
                timeout: 600000,
                success: function(data) {
                    //$('#threeDimensionalImage').val(data.content.fileId);
                    //saveProcess();
                },
                error: function(e) {
                    console.log('ERROR : ', e);
                }
            });
            */
        },
        base64ToBlob(data) {
            let mimeString = '';
            let raw, uInt8Array, i;
            const rImageType = /data:(image\/.+);base64,/;

            raw = data.replace(rImageType, function(header, imageType) {
                mimeString = imageType;
                return '';
            });

            raw = atob(raw);
            const rawLength = raw.length;
            uInt8Array = new Uint8Array(rawLength); // eslint-disable-line
            for (i = 0; i < rawLength; i += 1) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: mimeString });
        },
        async saveAndNext() {
            this.showLoading();

            //step1. 크롭을 했는지 체크한다.
            if (!this.isCrop) {
                await this.onClickedCropBtn();
            }

            //step2. 이미지를  SVG에서 Base65로 변환
            const base64ForFM = this.getImageBase64OfCurrentSvg();
            this.svgUrlToPng(base64ForFM);
        },
        saveProcess() {
            /*API를 호춣하고 저장한 후 이동한다. */
            const param = {
                id: this.data.id,
                threeDimensionalImage: this.data.threeDimensionalImage,
                threeDimensionalFile1: this.data.threeDimensionalFile1
            };

            FacemappingApi.putThreeDimensional(param).then(() => {
                this.hideLoading();
                this.$router.push({ path: `/step4/${this.data.id}` });
            });
        },
        displayMaskedImage(imageDataUrl) {
            //svg 마스킹을 이용하여 미지지를 자르는 방법
            const svgHTML = `
                <svg width="700px" height="720px" viewBox="0 0 700 720" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <mask id="maskExample">
                            <rect width="100%" height="100%" fill="white"/>
                            <path fill="black" d="M0,0v720h700V0H0z M695,366v349H5V366h0.1c0-2-0.1-4-0.1-6C5,163.9,159.5,5,350,5s345,158.9,345,355
                        C695,362,695,364,695,366L695,366z"/>

                        </mask>
                    </defs>
                    <image xlink:href="${imageDataUrl}" width="100%" height="100%" mask="url(#maskExample)"/>
                </svg>
                `;
            document.getElementById('svgContainer').innerHTML = svgHTML;
        },
        cropDisplayMaskedImage(imageDataUrl) {
            //svg 마스킹을 이용하여 미지지를 자르는 방법
            const svgHTML = `
                <svg width="350px" height="360px" viewBox="0 0 700 720" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <mask id="maskExample">
                            <rect width="100%" height="100%" fill="white"/>
                            <path fill="black" d="M0,0v720h700V0H0z M695,366v349H5V366h0.1c0-2-0.1-4-0.1-6C5,163.9,159.5,5,350,5s345,158.9,345,355
                        C695,362,695,364,695,366L695,366z"/>

                        </mask>
                    </defs>
                    <image xlink:href="${imageDataUrl}" width="100%" height="100%" mask="url(#maskExample)"/>
                </svg>
                `;
            document.getElementById('cropImgUrl').innerHTML = svgHTML;
        },
        async onClickedCropBtn() {
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            this.displayMaskedImage(this.cropImg);
            this.cropDisplayMaskedImage(this.cropImg);
            $('#threeDimensionalImageUrl').hide();
            this.isCrop = true;
        },
        onCropperReady() {
            // 이미지가 준비된 후 초기 크롭 위치와 크기를 설정
            this.$refs.cropper.setCropBoxData({
                left: 200, // 크롭 박스의 x 좌표
                top: 50, // 크롭 박스의 y 좌표
                width: 320, // 초기 크롭 높이
                height: 320 // 초기 크롭 높이
            });
        }
    }
};
</script>
